__turbopack_context__.v({
  "Counter": "r2JbSa_Counter",
  "Nav": "r2JbSa_Nav",
  "NavButton": "r2JbSa_NavButton",
  "skeleton-loading": "r2JbSa_skeleton-loading",
});
